<style lang="css" scoped>
.wx-pagesplit {
    padding-bottom: 9px;
    margin: 20px 0 10px;
    border-bottom: 1px solid #eeeeee;
}
</style>

<template>
<div class="wx-pagesplit">{{title?title:'--'}}</div>
</template>

<script>
export default {
    props: {
        title: {
            type: String
        }
    }
};
</script>





// WEBPACK FOOTER //
// src/components/core/split/Split.vue